import { ITypeOffer, TypeOffer } from './../models/typeOffer.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';
import { IPostPromotion, PostPromotion } from '../models/postPromotion.model';
import { IPost } from '../models/post.model';
import { IPromotion, Promotion } from '../models/promotion.model';

@Injectable({
  providedIn: 'root'
})

export class PostPromotionService {

  constructor(private http: HttpClient) {}

  getPostPromotion(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/postPromotion/all`, {'headers': headers});
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/postPromotion` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getPostPromotionBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/postPromotion` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  savePostPromotion(postPromotion: IPostPromotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/postPromotion`, postPromotion, {'headers': headers});
  }

  // api/post-promotion/{id} => date de début et date de fin
  updtatePostPromotion(postPromotion: IPostPromotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post-promotion/` + postPromotion.id, postPromotion, {'headers': headers});
  }

  // https://apidev.kahpoo.com/api/post-promotion/apply-for-seller => PUT
  validPostPromotion(postPromotion: IPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post-promotion/seller/`+ postPromotion.id, postPromotion, {'headers': headers});
  }

  // api/promotion/kahpoo-promotion/{id} => PutMapping
  validKahpooPostPromotion(postPromotion: Promotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/promotion/kahpoo-promotion/`+postPromotion.id, postPromotion, {'headers': headers});
  }

  // api/post-promotion/enable/{id}
  enablePostPromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/post-promotion/enable/` + id, {'headers': headers});
  }

  //api/promotion/enable/{id}
  enableKahpooPromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promotion/enable/` + id, {'headers': headers});
  }

  //api/promotion/disable/{id}
  disableKahpooPromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/promotion/disable/` + id, {'headers': headers});
  }

  // api/post-promotion/disable/{id}
  disablePostPromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put(`${environment.url}/post-promotion/disable/` + id, {'headers': headers});
  }

  getIdPostPromotion(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/post-promotion/one/` + id, {'headers': headers});
  }

  updatePostPromotion(postPromotion: IPostPromotion) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/postPromotion/` + postPromotion.id, postPromotion, {'headers': headers});
  }
  deletePostPromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/post-promotion/` + id, {'headers': headers});
  }

  deletePromotion(id: any) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/promotion/` + id, {'headers': headers});
  }

}
